import '../../../styles/Form.css';
import './HealthCard.css';
import "es6-shim";
import * as React from 'react';
import { MyleInstanceClinicSettings, PreferredPharmacyCheckin } from '../../../dtos/KioskDtos.dtos';
import { IGenericsLang } from '../../../services/Language/Types';
import { PreferredPharmacyAutoComplete } from '../../PreferredPharmacyAutoComplete/PreferredPharmacyAutoComplete';

export interface IPreferredPharmacyEditProps {
    focusedInputName: string,
    lang: string,
    preferredPharmacy: PreferredPharmacyCheckin,
    text: IGenericsLang,
    myleClinicSettings: MyleInstanceClinicSettings;
    cancel(): void,
    save(preferredPharmacy: PreferredPharmacyCheckin): void,
    onFocus: (pipe: (value: any) => void, value: any, mask: string, id: string) => void,
}


export const PreferredPharmacyEdit = (props: IPreferredPharmacyEditProps) => {
    const [preferredPharmacy, setPreferredPharmacy] = React.useState<PreferredPharmacyCheckin>(props.preferredPharmacy);

    const onSave = () => {
        props.save(preferredPharmacy);
    }

    const textString = props.text;
    return (
        <div style={{ height: "60vh", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div className="preferred-pharmacy-search" style={{ padding: "0px 75px" }}>
                <PreferredPharmacyAutoComplete
                    langCode={props.lang}
                    onChange={(pharmacy: PreferredPharmacyCheckin) => {
                        setPreferredPharmacy(pharmacy);
                    }}
                    existingPreferredPharmacy={preferredPharmacy}
                    focusedInputName={props.focusedInputName}
                    onFocus={props.onFocus}
                    text={textString}
                    isContactDirectoryEnabled={props.myleClinicSettings.enableContactDirectory}
                />
            </div>
            <div className="row">
                <div className="col-sm-12 text-center">
                    <button
                        className="buttons-white"
                        onClick={props.cancel}
                    >
                        {textString.labels.CancelButton}
                    </button>
                    <button
                        className="buttons-blue"
                        onClick={onSave}
                    >
                        {textString.labels.SaveButton}
                    </button>
                </div>
            </div>

        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/PreferredPharmacyEdit.tsx